import {
  SET_ACCESS_TOKEN,
  SET_MY_INFO,
  DESTROY_ACCESS_TOKEN,
  DESTROY_MY_INFO,
  SET_KAKAO_ACCOUNT,
  DESTROY_KAKAO_ACCOUNT
} from "./mutations-types";
import api from "@/api";
import Cookies from "js-cookie";
const CookieName = process.env.VUE_APP_CookieName;
const CookieToken = process.env.VUE_APP_CookieToken;

export default {
  [SET_ACCESS_TOKEN](state, accessToken) {
    if (accessToken) {
      state.accessToken = accessToken;
      api.defaults.headers.common["authorization"] = `Bearer ${accessToken}`;
      Cookies.set(CookieToken, accessToken, { expires: 100000 });
    }
  },
  [DESTROY_ACCESS_TOKEN](state) {
    state.accessToken = "";
    delete api.defaults.headers.common["authorization"];
    Cookies.remove(CookieToken);
    Cookies.remove(CookieName);
  },
  [SET_MY_INFO](state, me) {
    if (me) {
      state.me = me;
    }
  },
  [DESTROY_MY_INFO](state) {
    state.me = null;
  },
  [SET_KAKAO_ACCOUNT](state, data) {
    if (data) {
      state.kakaoAccount = data;
    }
  },
  [DESTROY_KAKAO_ACCOUNT](state, data) {
    state.kakaoAccount = null;
  },
};
